/* Large variant dropdown — Simply Carbon Fiber's own file (2026-09-11), part of the Easy Variation
   Swatches replacement. <scf-dropdown> wraps the theme's native <select> (rendered by
   snippets/variant-dropdown.liquid), hides it, and draws a big toggle + a tall option list that
   drives the select, so theme.js (price, availability, gallery) keeps working unchanged.
   Sold-out options stay choosable (so the back-in-stock button can be reached) and show struck through, as
   before; they are flagged with data-soldout on the native option by snippets/variant-dropdown.liquid and
   snippets/scf-bis.liquid (2026-09-25). Phones (max-width 768px) skip the custom list and use the native
   picker instead: the select itself is shown, styled like the toggle, so the field and its label open the
   same iOS/Android wheel (2026-09-25, Sergio: one master per device). Keyboard:
   Enter/Space/ArrowDown open, arrows move, Enter selects, Esc closes. Theme settings → Product
   options → Dropdown style switches back to the native select. */
(function () {
  if (typeof window === 'undefined' || !window.customElements || customElements.get('scf-dropdown')) return;
  var CHEV = '<svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var uid = 0;

  class ScfDropdown extends HTMLElement {
    connectedCallback() {
      var self = this, select = this.select = this.querySelector('select');
      if (!select || this.toggle || this.classList.contains('scf-dd--native')) return;
      this.id = this.id || 'scf-dd-' + (++uid);
      this.valueOut = this.closest('.variant-wrapper') ? this.closest('.variant-wrapper').querySelector('[data-scf-dd-value]') : null;
      if (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) {
        /* phone: the native picker is the master */
        this.classList.add('scf-dd--native');
        select.classList.add('scf-dd__native');
        select.addEventListener('change', function () { var o = select.options[select.selectedIndex]; if (self.valueOut) self.valueOut.textContent = o ? o.text.trim() : ''; });
        return;
      }
      select.setAttribute('aria-hidden', 'true'); select.tabIndex = -1; select.classList.add('scf-dd__native');
      this.toggle = document.createElement('button');
      this.toggle.type = 'button'; this.toggle.className = 'scf-dd__toggle';
      this.toggle.setAttribute('aria-haspopup', 'listbox'); this.toggle.setAttribute('aria-expanded', 'false'); this.toggle.setAttribute('aria-controls', this.id + '-list');
      this.list = document.createElement('ul');
      this.list.className = 'scf-dd__list'; this.list.id = this.id + '-list'; this.list.setAttribute('role', 'listbox'); this.list.tabIndex = -1; this.list.hidden = true;
      this.appendChild(this.toggle); this.appendChild(this.list);
      this.render();
      /* the label above the field opens our list too, instead of focusing the hidden select */
      var label = this.label = select.id ? document.querySelector('label[for="' + select.id + '"]') : null;
      if (label) label.addEventListener('click', function (e) { e.preventDefault(); self.open(true); self.focusItem(self.selectedIndex()); });
      this.toggle.addEventListener('click', function () { self.open(!self.isOpen()); });
      this.toggle.addEventListener('keydown', function (e) { if (['ArrowDown', 'ArrowUp', 'Enter', ' '].indexOf(e.key) !== -1) { e.preventDefault(); self.open(true); self.focusItem(self.selectedIndex()); } });
      this.list.addEventListener('click', function (e) { var li = e.target.closest('[role="option"]'); if (li) self.choose(li.dataset.value); });
      this.list.addEventListener('keydown', function (e) { self.onListKey(e); });
      document.addEventListener('click', this.onDocClick = function (e) { if (!self.contains(e.target) && !(self.label && self.label.contains(e.target))) self.open(false); });
      select.addEventListener('change', function () { self.render(); });
      this.observer = new MutationObserver(function () { self.render(); });
      this.observer.observe(select, { attributes: true, subtree: true, childList: true, attributeFilter: ['disabled', 'selected', 'data-soldout'] });
    }
    disconnectedCallback() { document.removeEventListener('click', this.onDocClick); if (this.observer) this.observer.disconnect(); }
    isOpen() { return !this.list.hidden; }
    selectedIndex() { return Math.max(0, this.select.selectedIndex); }
    render() {
      var self = this, sel = this.select, current = sel.options[sel.selectedIndex];
      var soldOut = function (o) { return !!o && (o.disabled || o.getAttribute('data-soldout') === 'true'); };
      this.toggle.innerHTML = '<span class="scf-dd__value">' + (current ? current.text.trim() : '') + '</span>' + CHEV;
      if (this.valueOut) this.valueOut.textContent = current ? current.text.trim() : '';
      this.list.innerHTML = '';
      Array.prototype.forEach.call(sel.options, function (opt, i) {
        var li = document.createElement('li');
        li.className = 'scf-dd__item'; li.setAttribute('role', 'option'); li.dataset.value = opt.value; li.id = self.id + '-opt-' + i; li.tabIndex = -1;
        li.setAttribute('aria-selected', String(i === sel.selectedIndex));
        li.textContent = opt.text.trim();
        if (soldOut(opt)) li.classList.add('is-soldout');
        self.list.appendChild(li);
      });
    }
    open(state) {
      this.list.hidden = !state; this.toggle.setAttribute('aria-expanded', String(state)); this.classList.toggle('scf-dd--open', state);
      if (state) { var li = this.list.children[this.selectedIndex()]; if (li) li.scrollIntoView({ block: 'nearest' }); }
    }
    focusItem(i) { var items = this.list.children; if (!items.length) return; i = (i + items.length) % items.length; items[i].focus(); }
    onListKey(e) {
      var items = Array.prototype.slice.call(this.list.children), i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); this.focusItem(i + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); this.focusItem(i - 1); }
      else if (e.key === 'Home') { e.preventDefault(); this.focusItem(0); }
      else if (e.key === 'End') { e.preventDefault(); this.focusItem(items.length - 1); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (i >= 0) this.choose(items[i].dataset.value); }
      else if (e.key === 'Escape' || e.key === 'Tab') { this.open(false); this.toggle.focus(); }
    }
    choose(value) {
      if (this.select.value !== value) { this.select.value = value; this.select.dispatchEvent(new Event('change', { bubbles: true })); }
      this.render(); this.open(false); this.toggle.focus();
    }
  }
  customElements.define('scf-dropdown', ScfDropdown);
})();
